"use client";

import { cn } from "@/lib/tailwind";
import ResponsiveCarousel from "@/components/ui/responsiveCarousel/ResponsiveCarousel";

export interface BundleVariant {
  id: string;
  name: string;
  title: string;
}

interface BundleVariantSelectorProps {
  variants: BundleVariant[];
  selectedVariantId: string;
  onVariantChange: (variantId: string) => void;
  className?: string;
}

const BundleVariantSelector = ({
  variants,
  selectedVariantId,
  onVariantChange,
  className,
}: BundleVariantSelectorProps) => {

  const handleVariantClick = (variantId: string) => {
    if (variantId !== selectedVariantId) {
      onVariantChange(variantId);
    }
  };

  if (!variants || variants.length === 0) return null;

  return (
    <div className={cn("w-full max-w-[100vw] bg-[#FAFAFA] relative", className)}>
      <div className="container h-full min-h-[4rem] w-full flex items-center justify-start px-4 md:px-12 lg:px-0">
        <div className="w-full">
        <ResponsiveCarousel
            gap={{ mobile: 4, desktop: 4 }}
            className="justify-start py-2"
            arrowPosition="outside"
          >            
            {variants.map((variant) => {
              const isSelected = variant.id === selectedVariantId;
              return (
                <button
                  key={variant.id}
                  type="button"
                  onClick={() => handleVariantClick(variant.id)}
                  title={variant.title}
                  className={cn(
                    "flex-shrink-0 cursor-pointer px-4 py-2 text-sm font-semibold transition-colors truncate max-w-[160px] md:max-w-none md:whitespace-nowrap",
                    isSelected
                      ? "bg-[#BBB6A5] text-white"
                      : "bg-[#EDEDED] text-black hover:bg-[#E0E0E0]"
                  )}
                >
                  {variant.title}
                </button>
              );
            })}
          </ResponsiveCarousel>
        </div>
      </div>
    </div>
  );
};

export default BundleVariantSelector;
